import * as R from 'ramda';
/**
 * 例えばfind系とかの何かの値を得られることが期待されているが見つからず返す値が無い、というとき、NULLではなくこの値を使う。これにより条件分岐処理が安全にしやすくなる。
 */
export const VALUE_NONE = 'VALUE_NONE';
export type t_valueNone = typeof VALUE_NONE;
/**
 * isNilとisEmptyの複合版。isNilかisEmpty両方を試しどちらかがtrueならtrue。
 * @param a
 * @returns
 */
export const isNilOrEmpty = R.ifElse(
	R.isNil,
	R.always(true),
	R.ifElse(R.isEmpty, R.always(true), R.always(false)),
);
/**
 * nil系を受け取ったらNONEを返す。
 * 自作関数では直接NONEを返せばいいし、ライブラリはthrowIfEqualsを使えばいいから要らないかも
 * @param e
 * @returns
 */
export const nilIntoNone = <T>(e: T) => (R.isNil(e) ? VALUE_NONE : e);
/**
 * NONEだったら例外を投げる。
 * 
 * 例：pathの結果がundefinedだったらpipeを途中で抜けて'NO PATH'を返す。
		const testval = {a:100,b:200}
		const f = R.pipe(R.path('a'), nilIntoNone, throwIfNone, R.equals(100))

		R.tryCatch(f, R.always('NO PATH'))(testval)
 * @param e 
 * @returns 
 */
export const throwIfNone = <T>(e: T | t_valueNone) => {
	if (e === VALUE_NONE) {
		throw new Error('VALUE_NONE THROW');
	}
	return e;
};

/**
 * 第1引数がカリー引数と等しければ例外。
 * @param v
 * @returns
 */
export const throwIfEquals =
	<T>(v: any) =>
	(e: any): T => {
		if (v === e) {
			throw new Error('EQUALS THROW');
		}
		return e;
	};
